import { Component, Input } from "@angular/core";

@Component({
  selector: "app-status206ab-card",
  templateUrl: "./status206ab-card.component.html",
  styleUrls: ["./status206ab-card.component.scss"],
})
export class Status206abCardComponent {
  @Input() data: any = null;

  get complianceData(): any {
    return this.data?.complianceData || {};
  }

  get isCompliant(): boolean {
    return (
      this.complianceData?.panStatus === "operative" &&
      this.complianceData?.specifiedPersonUs206ab206cca === "n"
    );
  }

  get panStatusDisplay(): string {
    return this.complianceData?.panStatus?.toUpperCase() || "UNKNOWN";
  }

  get financialYearDisplay(): string {
    return this.complianceData?.financialYear || "N/A";
  }

  get status206ABDisplay(): string {
    const specified = this.complianceData?.specifiedPersonUs206ab206cca;
    return specified === "n" ? "NOT SPECIFIED" : "SPECIFIED";
  }

  get status206ABClass(): string {
    const specified = this.complianceData?.specified_person_us_206ab_206cca;
    return specified === "n"
      ? "bg-green-100 text-green-800"
      : "bg-red-100 text-red-800";
  }

  get panStatusClass(): string {
    return this.isCompliant
      ? "bg-green-100 text-green-800"
      : "bg-red-100 text-red-800";
  }
}
